import { render, staticRenderFns } from "./ContestFormsView.vue?vue&type=template&id=29ff5a88&scoped=true&"
import script from "./ContestFormsView.vue?vue&type=script&lang=js&"
export * from "./ContestFormsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff5a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VCard,VContainer})
